export default __webpack_public_path__ + "static/upscale_back-c28a2a3b7d80f702441fc5a3dff39a6d.webp";